import React, {Component} from 'react';
import {useNavigate} from "react-router-dom";
import styles from './index.module.css'
import {useGlobalState} from "../../utils/GlobalStateContext";

function Index(props:any) {
  const navigate = useNavigate()
  const { state, dispatch } = useGlobalState();
  console.log('获取状态结果',state.project_name)
  return (
    <div className={styles.pageContainer}>
      <div className={styles.header}>
        <div className={styles.title}>
          {state.project_name}
        </div>
        <div className={styles.navbar}>
          <div className={styles.item} onClick={()=> {
            navigate('/collect/list');
          }}>
            <img src={require('../../static/img/caiji.png')}/>
            <br/>
            <span style={{marginTop:2}}>信息采集</span>
          </div>
          <div className={styles.item} onClick={()=> {
            navigate('/device/bind');
          }}>
            <img src={require('../../static/img/bangding.png')}/>
            <br/>
            <span style={{marginTop:2}}>设备绑定</span>
          </div>
          <div className={styles.item} onClick={()=> {
            navigate('/warn/list');
          }}>
            <img src={require('../../static/img/ziliao.png')}/>
            <br/>
            <span style={{marginTop:2}}>预警处置</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Index;
